import React from 'react';
import styled from 'styled-components';

const Title = styled.h2`
  font-size: 3rem;
  color: #1c9dbd;
  font-weight: 900;
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
  width: 100%;
  padding-bottom: 0.5rem;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 4px;
    background: linear-gradient(135deg, #ff9d5c 0%, #ff8533 100%);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }
`;

interface SectionTitleProps {
  children: React.ReactNode;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => {
  return <Title>{children}</Title>;
};

export default SectionTitle; 